export const BILLING_STATUS = [
  {
    value: 'notPaid',
    label: 'Not paid',
  },
  {
    value: 'paid',
    label: 'Paid',
  },
  {
    value: 'sent',
    label: 'Sent',
  },
];
